// check is an item exist in a storage
// we use only localstorage for analytics data because redux is more difficult to use here
const waitForItem = <T>(getItem: () => Promise<T>): Promise<T | undefined> =>
	new Promise(async resolve => {
		const wait = async (attempts: number) => {
			try {
				if (attempts === 50) {
					resolve(undefined)
					return
				}

				const item = await getItem()

				if (item) {
					resolve(item)
				} else setTimeout(() => wait(attempts++), 100)
			} catch (error) {
				resolve(undefined)
			}
		}

		await wait(0)
	})

export default waitForItem
